var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHostingControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3994_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7812 34.5938H4.21875C2.66548 34.5938 1.40625 33.3345 1.40625 31.7812V26.1562C1.40625 24.603 2.66548 23.3438 4.21875 23.3438H31.7812C33.3345 23.3438 34.5938 24.603 34.5938 26.1562V31.7812C34.5938 33.3345 33.3345 34.5938 31.7812 34.5938Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3396 12.0938H31.7812C33.3345 12.0938 34.5938 13.353 34.5938 14.9062V20.5312C34.5938 22.0845 33.3345 23.3438 31.7812 23.3438H4.21875C2.66548 23.3438 1.40625 22.0845 1.40625 20.5312V14.9062C1.40625 13.353 2.66548 12.0938 4.21875 12.0938H5.66051",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.25 28.9688H26.4375",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.25 17.7188H26.4375",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 28.9688,
    r: 1.40625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.375,
    cy: 28.9688,
    r: 1.40625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 17.7188,
    r: 1.40625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7141 4.38342L16.6783 1.73559C17.0723 1.52536 17.5222 1.40625 18 1.40625C18.4778 1.40625 18.9277 1.52536 19.3217 1.73559L24.2859 4.38342C24.7294 4.61995 25.0312 5.08725 25.0312 5.625V9.28125C25.0312 11.3823 24.1097 13.2682 22.6487 14.5566L19.8595 17.0164C19.3638 17.4535 18.7129 17.7188 18 17.7188C17.2871 17.7188 16.6362 17.4535 16.1405 17.0164L13.3522 14.5574C11.8907 13.269 10.9688 11.3828 10.9688 9.28125V5.625C10.9688 5.08725 11.2706 4.61995 11.7141 4.38342Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3994_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostingControl);
export default __webpack_public_path__ + "static/media/hosting-control.c4f972fd76b4c88e61e841e98954e39d.svg";
export { ForwardRef as ReactComponent };